package one.healthium.tasks.domain

data class DailyTaskModel(
    val id: String,
    val info: DailyTaskInfoModel,
    val completionCount: Int,
) {
    val completed = completionCount > 0
    val type = info.type
    val name = info.name

    companion object {
        val previewLogWeight = DailyTaskModel(
            id = "test",
            info = DailyTaskInfoModel(
                type = DailyTaskType.LogWeight,
                name = "Log Weight",
                color = 0xFFFFFFFF,
            ),
            completionCount = 0,
        )
        val previewLogWater = DailyTaskModel(
            id = "test",
            info = DailyTaskInfoModel(
                type = DailyTaskType.LogWater,
                name = "Log Water",
                color = 0xFFFFFFFF,
            ),
            completionCount = 0,
        )

    }
}

sealed interface DailyTaskType {
    data object LogWeight : DailyTaskType
    data object LogWater : DailyTaskType
    data class ReadInsight(
        val id: String,
    ) : DailyTaskType

    data object LogFood : DailyTaskType

    data class DoWorkout(
        val id: String,
    ) : DailyTaskType

    data object LogSymptoms : DailyTaskType
}